// extracted by mini-css-extract-plugin
export default {"congrats":"newBadgeCongratulation_congrats__MMgm0","close":"newBadgeCongratulation_close__TC8qX","container":"newBadgeCongratulation_container__E7Qf1"};